import Immutable from 'immutable';
import * as constants from '../../constants/apiCallsConstants';

const initialStateValue = {
  data_ready: false,
  usage: [],
  periods: [],
  status: '',
  error: {},
};

const initialState = Immutable.fromJS(initialStateValue);


const actionHandlers = {
  REQUEST_API_CALLS_DETAILS: state =>
    state.merge(initialStateValue),

  RECEIVE_API_CALLS_DETAILS: (state, action) => state.mergeDeep({
    data_ready: true,
    usage: action.usage,
    periods: action.periods,
    status: action.status,
    receipt: action.receipt,
  }),

  REQUEST_API_CALLS_SUMMARY: state =>
    state.merge(initialStateValue),

  RECEIVE_API_CALLS_SUMMARY: (state, action) => state.mergeDeep({
    data_ready: true,
    usage: action.usage,
    periods: action.periods,
    status: action.status,
    receipt: action.receipt,
  }),

  SERVICE_ERROR: (state, action) =>
    state.mergeDeep({ data_ready: true, error: action.error }),
};

export default (state = initialState, action) => {
  const actionHandler = actionHandlers[action.type];

  return (actionHandler)
    ? actionHandler(state, action)
    : state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/integrationsReducer.js
 **/